<template>
  <!-- 多选题 -->
  <div class="question-item">
    <div class="title-box">
      <span class="line-name">选项</span>
      <span class="line-dec" v-if="!readOnly">多选题的选项范围从{{ minOptions }}-{{ maxOptions }}个</span>
    </div>
    <div class="multiple option">
      <div class="option-content">
        <div class="option-item" v-for="(item, index) in optionsCopy" :key="item['exam_questions_options.ds_order']">
          <div class="item-line1">
            <div class="item-order">
              <el-checkbox :disabled="readOnly" size="medium" v-model="checkbox[index]"> </el-checkbox>
            </div>
            <div class="item-text">
              <el-input
                v-if="!readOnly"
                :disabled="readOnly"
                v-model="item['exam_questions_options.name']"
                placeholder="请输入内容"
                :maxlength="inputlength"
              />
              <el-input
                v-else
                :disabled="readOnly"
                v-model="item['exam_questions_options.name']"
                placeholder="请输入内容"
                :maxlength="inputlength"
                :autosize="readOnly"
                type="textarea"
              />
            </div>
            <div class="item-del" v-if="!readOnly">
              <i class="el-icon-error" @click="delOption(item, index)"></i>
            </div>
          </div>
          <div class="item-line2">
            <DsfQuestionUpLoadImg
              :fileList="item['exam_questions_options.imgs']"
              :optionsId="item['exam_questions_options.ds_order']"
              :readOnly="readOnly"
              @get-imglist="getImgList"
            />
          </div>
        </div>
      </div>
      <div class="option-add" v-if="!readOnly">
        <DsfButton type="plain" icon="add" @click="addOption">添加选项</DsfButton>
      </div>
    </div>
  </div>
</template>

<script>
import DsfQuestionUpLoadImg from "./UploadImg.vue";
export default {
  name: "DsfMultiple",
  mixins: [$mixins.examquestion],
  components: { DsfQuestionUpLoadImg },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    exam_questions_options: {
      type: Array,
      // default: false,
    },
    saveStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { checkbox: [], dsorder: 0 };
  },
  computed: {
    optionsCopy() {
      return this.exam_questions_options.filter((item) => item["exam_questions_options.ds_deleted"] !== 1);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.exam_questions_options.forEach((item, index) => {
        this.$set(this.exam_questions_options[index], "exam_questions_options.ds_order", index);
        this.$set(this.exam_questions_options[index], "type", "multiple");
      });
      if (!this.readOnly && !this.$route.query.id && this.exam_questions_options.length <= 0) {
        this.init();
      }
      if (this.$route.query.id) {
        this.exam_questions_options.forEach((item, index) => {
          if (item["exam_questions_options.is_right"].value == 1) {
            this.checkbox.push(true);
          } else {
            this.checkbox.push(false);
          }
        });
      }
    });
  },
  methods: {
    getImgList(imgList, optionsId) {
      this.exam_questions_options.forEach((item, index) => {
        if (item["exam_questions_options.ds_order"] == optionsId) {
          this.exam_questions_options[index]["exam_questions_options.imgs"] = JSON.stringify(imgList);
        }
      });
    },
    addOption() {
      var order = this.optionsCopy.length;
      // var isNull = this.checkNull();
      // if (!isNull) {
      // } else {
      //   dsf.layer.message(`多选题的选项内容没有设置，请先输入内容`, false);
      // }
      if (order < this.maxOptions) {
        this.checkbox.push(false);
        this.dsorder += 1;
        this.exam_questions_options.push({
          "exam_questions_options.name": "",
          "exam_questions_options.imgs": "[]",
          "exam_questions_options.ds_order": this.dsorder,
          "exam_questions_options.is_right": false,
          type: "multiple",
        });
      } else {
        dsf.layer.message(`多选题的选项最多为 ${this.maxOptions}个`, false);
      }
    },
    delOption(item, _index) {
      this.checkbox.splice(_index, 1);
      this.exam_questions_options.forEach((ele, index) => {
        if (ele["exam_questions_options.ds_order"] == item["exam_questions_options.ds_order"]) {
          if (item._id) {
            this.$set(this.exam_questions_options[index], "exam_questions_options.ds_deleted", 1);
            this.$delete(this.exam_questions_options[index], "exam_questions_options.ds_order");
          } else {
            this.exam_questions_options.splice(index, 1);
          }
        }
      });
      this.$emit("validate-single", false);
    },
    checkNull() {
      // this.optionsCopy
      return this.exam_questions_options.some(
        (item) =>
          (item["exam_questions_options.imgs"] == "[]" || !item["exam_questions_options.imgs"]) &&
          !item["exam_questions_options.name"] &&
          item["exam_questions_options.ds_deleted"] != 1
      );
    },
    checkAnswer() {
      // this.optionsCopy
      var rightArray = this.exam_questions_options.filter(
        (item) => item["exam_questions_options.is_right"].value == 1 && item["exam_questions_options.ds_deleted"] != 1
      );
      return rightArray.length > 1;
    },
    init() {
      for (let i = 0; i < this.minOptions; i++) {
        this.checkbox.push(false);
        this.exam_questions_options.push({
          "exam_questions_options.name": "",
          "exam_questions_options.imgs": "[]",
          "exam_questions_options.ds_order": i,
          "exam_questions_options.is_right": false,
          type: "multiple",
        });
      }
    },
  },
  watch: {
    checkbox: {
      handler(val) {
        var _index = 0;
        this.exam_questions_options.forEach((item, index) => {
          if (item["exam_questions_options.ds_deleted"] != 1) {
            if (this.checkbox[_index]) {
              this.exam_questions_options[index]["exam_questions_options.is_right"] = {
                text: "是",
                value: "1",
              };
            } else {
              this.exam_questions_options[index]["exam_questions_options.is_right"] = {
                text: "否",
                value: "0",
              };
            }
            _index++;
          }
        });
      },
      deep: true,
    },
    saveStatus(val) {
      if (val) {
        // var result = this.exam_questions_options.filter(
        //   (item) => item["exam_questions_options.ds_deleted"] !== 1
        // );
        if (this.optionsCopy.length < this.minOptions) {
          dsf.layer.message(`请添加选项，多选题的选项至少为${this.minOptions}个`, false);
          this.$emit("set-savestatus", false);
          this.$emit("set-savestatus", false);
          return;
        }
        var isNull = this.checkNull();
        if (!isNull) {
          var checked = this.checkAnswer();
          if (!checked) {
            dsf.layer.message("多选题的正确答案至少两个", false);
            this.$emit("set-savestatus", false);
            this.$emit("set-validatesuc", false);
          } else {
            this.$emit("set-validatesuc", true);
          }
        } else {
          this.$emit("set-savestatus", false);
          this.$emit("set-validatesuc", false);
          dsf.layer.message(`多选题的选项内容没有设置，请先输入内容`, false);
        }
      }
    },
    exam_questions_options: {
      handler(val) {
        if (this.dsorder == 0) {
          this.dsorder = val.length - 1;
        }
        if (val.length < 1) {
          // this.init();
          this.checkbox = [];
        }
      },
      deep: true,
    },
  },
};
</script>

<style></style>
